import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from 'components/library';
import { Alert } from 'components/Icon';

import * as S from './styled';

import { ISubscriptionRedemption } from '../types';

import SubscriptionCardWrapper from './SubscriptionCardWrapper';
import SubscriptionCardHeader from './SubscriptionCardHeader';
import PriceRow from './PriceRow';
import { IncludedInYourPlanRow } from './IncludedInYourPlanRow';
import CancelSubscriptionBlock from './CancelSubscriptionBlock';

const SubscriptionRedemption = ({
    tabIcon,
    heading,
    subscriptionPeriod,
    price,
    onCancelSubscription,
    subscriptionType,
    isUpgrade,
    isOneTimeProduct,
    expirationDate,
}: ISubscriptionRedemption) => {
    const { t } = useTranslation();

    return (
        <SubscriptionCardWrapper>
            <SubscriptionCardHeader Icon={tabIcon} heading={heading} />
            <S.GeneralInfo>
                <S.Status>
                    <Alert />

                    <Text type="caption" color="text-secondary">
                        {t('subscription.status.active')}
                    </Text>
                    <Text type="caption" color="text-secondary">
                        :
                    </Text>
                </S.Status>
                <PriceRow period={subscriptionPeriod} subscriptionType={subscriptionType} price={price} />
                {isUpgrade && <IncludedInYourPlanRow isCardRow />}
            </S.GeneralInfo>
            <Text type="medium-text" bold color="critical-default" mb={4}>
                {t('subscription.text.awaitingPayment')}
            </Text>
            <Text type="small-text" color="text-secondary">
                {t('subscription.text.payYourBalance')}
            </Text>
            <CancelSubscriptionBlock
                isOneTimeProduct={isOneTimeProduct}
                date={expirationDate}
                onCancel={onCancelSubscription}
                paddingTop={20}
            />
        </SubscriptionCardWrapper>
    );
};

export default SubscriptionRedemption;
